module.exports = __webpack_public_path__ + "static/media/papeldeparede1.c9b8d2c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/papeldeparede1.png
// module id = 51
// module chunks = 0